import { render } from "./NewOrderBigud.vue?vue&type=template&id=0b0ba198&scoped=true"
import script from "./NewOrderBigud.vue?vue&type=script&lang=js"
export * from "./NewOrderBigud.vue?vue&type=script&lang=js"

import "./NewOrderBigud.vue?vue&type=style&index=0&id=0b0ba198&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0ba198"]])

export default __exports__